export default __webpack_public_path__ + "static/media/iconeMeusProvedores.17d9c306.png";